module.exports = __webpack_public_path__ + "img/htgs.39b8d4db.svg";